import React from "react";
import { IconProps } from "../Types";

const DownArrow = ({ className }: IconProps) => (
  <svg
    className={className}
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41 -4.66888e-07L6 4.59975L10.59 -6.21635e-08L12 1.41608L6 7.44195L-6.18988e-08 1.41608L1.41 -4.66888e-07Z"
      fill="#F5F7F5"
    />
  </svg>
);

export default DownArrow;
